import { observer } from "mobx-react";
import RmaShipmentStore from "../../../../stores/rma-shipment-store";
import { FONT_COLOR, FONT_VARIANT } from "../../../../../../../components/fonts/font-props";
import FontBody3 from "../../../../../../../components/fonts/font-body3/font-body3";
import RmaPageStore from "../../../../stores/rma-page-store";
import LabelOrSlipsCell from "../label-or-slips-cell/label-or-slips-cell";
import useDashboardTranslation from "../../../../../../../dashboard-translation/hooks/dashboard-translation-hook";

interface IProps {
    shipment: RmaShipmentStore;
    rmaPageStore: RmaPageStore;
};

const SlipsCell: React.FC<IProps> = observer(({ shipment, rmaPageStore }) => {
    const { getTranslation } = useDashboardTranslation();
    const pageScope = 'dashboard-returns-rma-card';
    return (
        rmaPageStore.rmaReturnMethod?.has_packing_slip || rmaPageStore.rmaReturnMethod?.has_address_slip
            ? (
                <LabelOrSlipsCell content={shipment.slipsContent()} rmaPageStore={rmaPageStore} />
            )
            : (
                <>
                    <FontBody3 color={FONT_COLOR.PRIMARY2} variant={[FONT_VARIANT.BOLD]}>{getTranslation('SLIPS_COLUMN', pageScope)}</FontBody3>
                    <FontBody3 color={FONT_COLOR.PRIMARY3_50}>{getTranslation('NOT_PROVIDED', pageScope)}</FontBody3>
                </>
            )
    );
});

export default SlipsCell;